export default __webpack_public_path__ + "static/media/heartFilled.5b2e96a9.svg";